import { combineReducers, createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";

import { reducer as notifications } from "react-notification-system-redux";

import {
  loginReducer,
  forgotPasswordReducer,
  resetPasswordReducer,
  invateReducer,
  queryPageRequest,
  queryPageByIdRequest,
  getRequest,
  getByIdRequest,
  postRequest,
  postByIdRequest,
  postSetRequest,
  putRequest,
  putByIdRequest,
  deleteRequest,
  setRequest,
  downloadRequest,
  reportActivityList,
  reportActivityProfileImage,
  newCount
} from "./redux/reducers/index";


const reducer = combineReducers({

  // Notification
  notifications: notifications,

  // Auth
  login: loginReducer,
  resetPassword: resetPasswordReducer,
  forgotPassword: forgotPasswordReducer,
  invateUser: invateReducer,
  //master
  countryList: getRequest('country/list'),
  languageList: getRequest('language/list'),
  interestList: getRequest('interest/list'),
  organizationList: getRequest('organization/list'),

  // Report
  programReportValidatorAssignedQueryPage: queryPageRequest('program/report/validator/assigned'),
  programReportId: getByIdRequest('program/report/id'),
  programReportAttachmentFileList: getByIdRequest('program/report/attachment/file/list'),
  programReportAttachmentFileDownload: downloadRequest('program/report/attachment/file/download'),  

  programReportActivityByReport: reportActivityList(),
  reportActivityProfileImage: reportActivityProfileImage(),
  // programReportActivityCommentCreate: postByIdRequest('program/report/activity/comment/create'),
  programReportTagAs: postSetRequest('program/report/activity/tag/report'),
  programReportSetReward: postByIdRequest('program/report/activity/set/reward'),
  programReportActivityAttachmentFileDownload: downloadRequest('program/report/activity/attachment/file/download'),

  // Program
  programStat: getByIdRequest('program/stat'),
  programReportStat: getByIdRequest('program/report/stat'),
  programId: getByIdRequest('program/id'),
  programScope: getByIdRequest('program/scope/byprogram'),
  programReward: getByIdRequest('program/reward/byprogram'),
  programUpdatesQueryPage: queryPageByIdRequest('program/update'),
  programUpdateId: getByIdRequest('program/update/id'),
  programScopeBeforeUpdateByprogram: getByIdRequest('program/scope/before/update/byprogram'),
  programScopeUpdateByprogram: getByIdRequest('program/scope/update/byprogram'),
  researcherProgramJoinRecentlyListByprogram: getByIdRequest('researcher/program/join/recently/list/byprogram'),

  //Hacktions
  programHacktionQueryPage: queryPageRequest('program/report/hacktion'),
  
  programReportSummaryId: getByIdRequest('program/report/summary/id'),
  programReportAttachmentFileHacktivityList: getByIdRequest('program/report/attachment/file/hactivity/list'),
  programReportAttachmentFileHacktivityDownload: downloadRequest('program/report/attachment/file/hactivity/download'),

  programReportHacktionActivityByReport: getByIdRequest('program/report/activity/byreport'),
  programReportActivityAttachmentFileHacktivityDownload: downloadRequest('program/report/activity/attachment/file/hactivity/download'),

   // Leaderboard
  leaderboardQueryPage: queryPageRequest('researcher/leaderboard'),
  // leaderboardLastWeekList: getRequest('leaderboard/lastweek/list'),
  // leaderboardLastMonthList: getRequest('leaderboard/lastmonth/list'),

  //Profile
  validatorProcessBar: getRequest('validator/profile/process/rate'),
  validatorProfileInformation: getRequest('validator/profile/base'),
  validatorProfileSub: getRequest('validator/profile/sub'),
  validatorProfileSkill: getRequest('validator/skill/mylist'),
  validatorProfileInterest: getRequest('validator/interest/mylist'),

  profileSecurityInformation: queryPageRequest('logging/login'),
  validatorProfilePreview: getRequest('validator/profile/preview'),

  validatorProfileInfoEdit: postRequest('validator/profile/personel/details/update'),
  validatorProfileSocialMediaEdit: postRequest('validator/profile/socialmedia/update'),
  validatorProfileAboutEdit: postRequest('validator/profile/about/update'),
  validatorProfileAddInterest: postRequest('validator/interest/save'),
  ImageSave: postRequest('user/save/profile/image'),

  researcherByIdProfileSub: getByIdRequest('researcher/profile/general/sub'),
  researcherByIdProfileInformation: getByIdRequest('researcher/profile/general/base'),
  researcherByIdProfileSkill: getByIdRequest('researcher/skill/general/byresearcher'),
  researcherByIdProfileInterest: getByIdRequest('researcher/interest/general/byresearcher'),
  researcherByIdProfilePerformance: getByIdRequest('researcher/profile/general/performance'),
  researcherByIdProfilePerformanceBadges: getByIdRequest('researcher/profile/general/badges'),
  researcherProfileGeneralProgramShow: getByIdRequest('researcher/profile/general/program/show'),
  researcherProgramRecentlyJoinedList: getByIdRequest('researcher/program/recently/joined/list'),
  researcherProgramRecentlyFollowingList: getByIdRequest('researcher/program/recently/following/list'),
  
  //Topbar Right Announcement
  notificationTaskNewCount: newCount('notification/task/newcount'),
  notificationActivityNewCount: newCount('notification/activity/newcount'),

  //Notification
  notificationTaskShort: queryPageRequest('notification/task/short'),
  notificationTask: queryPageRequest('notification/task'),
  notificationActivityShort: queryPageRequest('notification/activity/short'),
  notificationActivity: queryPageRequest('notification/activity'),

});

const store = createStore(reducer, applyMiddleware(thunk));

export default store;
